// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3YsFg","consentsList":"PatientConsents_consentsList__2_dRu","consentsListEmpty":"PatientConsents_consentsListEmpty__1UXLn"};